'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const HomepageHeader = () => {
  const [user, setUser] = useState<any>(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('authToken');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <header className="absolute top-0 left-0 right-0 z-50">
      <div className="absolute inset-0 bg-transparent" />
      
      <div className="relative max-w-[1920px] mx-auto px-[80px] py-[40px]">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link href="/" className="flex items-center" style={{ width: '367.62px', height: '94px' }}>
            <Image
              src="/header-transparent-logo.png"
              alt="Female Fitness Finder"
              width={367.62}
              height={94}
              className="object-contain"
              priority
            />
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-[40px]">
            <Link href="/" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">Home</Link>
            <Link href="/about" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">About</Link>
            <Link href="/search-process" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">Directory</Link>
            <Link href="/for-women" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">For Women</Link>
            <Link href="/contact" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">Contact</Link>
          </nav>

          {/* Right side actions */}
          <div className="flex items-center gap-[40px]">
            <div className="w-4 h-4">
              <Image
                src="/search-icon.svg"
                alt="Search"
                width={16}
                height={16}
                className="object-contain"
              />
            </div>
            
            {isLoggedIn && user ? (
              // Logged in user - show profile
              <Link href="/dashboard" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                {user.profilePicture ? (
                  <img
                    src={user.profilePicture}
                    alt={user.fullName}
                    className="w-10 h-10 rounded-full object-cover border-2 border-white"
                  />
                ) : (
                  <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center border-2 border-white">
                    <span className="text-[#8a7296] text-[16px] font-['Gotham_Rounded',sans-serif] font-bold">
                      {user.fullName?.charAt(0).toUpperCase()}
                    </span>
                  </div>
                )}
                <span className="font-['Archivo',sans-serif] text-[18px] text-white font-medium">
                  {user.fullName}
                </span>
              </Link>
            ) : (
              // Not logged in - show Register/Login
              <>
                <Link href="/signup" className="px-[34px] py-[20px] bg-[#8a7296] text-white font-['Archivo',sans-serif] text-[18px] font-medium leading-[100%] tracking-[0%] rounded-[10px] hover:bg-[#4C3E58] transition-colors flex items-center gap-2 backdrop-blur-sm">
                  Register
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
                <Link href="/login" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">Log In</Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default HomepageHeader;
